export const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST || 'https://admin.poncore.com';
export const BACKEND_WEBSOCKET_HOST = process.env.REACT_APP_BACKEND_WEBSOCKET_HOST || 'wss://admin.poncore.com';
